import { Method } from 'axios';

import authService from '@app/libs/auth/authService';

/* eslint-disable @typescript-eslint/no-explicit-any */

export const isModusignAPI = (url?: string): boolean => {
  return ['api.modusign.co.kr', 'stage.modusign.co.kr', 'gov.modusign.co.kr'].some(
    (domain) => url?.includes(domain) ?? false
  );
};

export const isMockAPI = (url: string): boolean => url.includes('mock.pstmn.io');

export const getJSONWebToken = (jwt?: string): string | null => jwt || authService.getAccessToken();
export const isExistJSONWebToken = (jwt?: string): boolean => !!jwt || authService.hasAccessToken();

/**
 *
 * @param {object} headers - http request headers
 * @param {string} url - http request url
 * @param {boolean} credentials - whether or not to need jwt
 * @param {string} token - JWT(JSON Web Token)
 */
export const createHTTPHeaders = (
  headers: any,
  url: string | undefined,
  credentials = false,
  token: string,
  baseURL?: string
): { Authorization: string; 'x-api-key': string } => {
  const modusignDefaultHeaders = {
    Authorization: 'none',
    'x-api-key': 'FidrahieciWU9wQrieCY4rjODW5WGIbaeFr8Li8e',
  };
  let result = { ...headers };

  if (isModusignAPI(url) || isModusignAPI(baseURL)) {
    result = { ...result, ...modusignDefaultHeaders };
  }

  if (credentials) {
    result = { ...result, Authorization: `Bearer ${token}` };
  }

  return result;
};

export const create401HTTPResponseError = (message = 'Unauthorized') =>
  Object.assign(new Error(message), {
    response: {
      status: 401,
      statusText: message,
    },
  });

/**
 * Disable Internet Explorer browser cache
 * @param {string} method - http request method
 * @param {Object} params - url query parameter map
 * @param {Boolean} disable - disable browser cache
 */
export const createIEBrowserCacheDisabledParam = (
  method: Method,
  params: any,
  disable = true
): Record<string, any> => {
  if (method.toUpperCase() !== 'GET' || !disable) {
    return params;
  }

  return {
    ...params,
    timestamp: new Date().getTime(),
  };
};
